/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AgencyState } from './agency-state';
import { MouDto } from './mou-dto';
import { AgencyStatus } from './agency-status';
import { MoaDto } from './moa-dto';


export interface AgencyFullDto { 
    accountDenialReason?: string;
    addressConfidential?: boolean;
    addressMailingCity?: string;
    addressMailingSameAsPhysical?: boolean;
    addressMailingStateLookup?: string;
    addressMailingStreet?: string;
    addressMailingZip?: string;
    addressPhysicalCity?: string;
    addressPhysicalStateLookup?: string;
    addressPhysicalStreet?: string;
    addressPhysicalZip?: string;
    adminEmail?: string;
    adminFirstName?: string;
    adminLastName?: string;
    adminPhone?: string;
    agencyDescription?: string;
    agencyEin?: string;
    agencyEmail?: string;
    agencyName?: string;
    agencyPhone?: string;
    agencyState?: AgencyState;
    agencyStatus?: AgencyStatus;
    agencyStatusDate?: string;
    agencyType?: AgencyFullDto.AgencyTypeEnum;
    agencyWebsite?: string;
    appointmentDurationInHours?: number;
    createdDate?: string;
    expiresDate?: string;
    id?: string;
    isTestAgency?: boolean;
    moa?: MoaDto;
    moaAgreement?: boolean;
    mou?: MouDto;
    olderThanYear?: boolean;
    primaryContactEmail?: string;
    primaryContactFirstName?: string;
    primaryContactLastName?: string;
    primaryContactPhone?: string;
    proposedInsuranceExpirationDate?: string;
    resubmissionReason?: string;
    serviceFamilyMember?: boolean;
    serviceProbationer?: boolean;
    serviceVictim?: boolean;
    version?: number;
}
export namespace AgencyFullDto {
    export const AgencyTypeEnum = {
        Private: 'PRIVATE',
        Public: 'PUBLIC'
    } as const;
    export type AgencyTypeEnum = typeof AgencyTypeEnum[keyof typeof AgencyTypeEnum];
}


